import React from 'react'
import Img from 'gatsby-image'

import Countdown from '../Countdown/countdown'

import HomeHeroLogo from '../../assets/icons/home-hero-logo'
import HeroApplyArrow from '../../assets/icons/hero-apply-arrow'

import './hero-home.scss'


const renderBackground = (background) => {
  const file = background.file

  if (file.contentType.startsWith('video')) {
    return (
      <video width="100%" muted autoPlay loop playsInline>
        <source src={ file.url } type="video/mp4" />
      </video>
    )
  } else {
    return (
      <Img className="hero-background-image" sizes={ background.sizes } />
      )
  }
}


const HeroHome = ({ content, lang, localization }) => {
  const background = renderBackground(content.background)

  if (content) {
    return (
      <div className="hero-container" data-cy="hero">

        <div className="hero-background-image-wrapper">
          { background }
        </div>
        <div className={`hero-content ${lang}`}>
          <div className={`hero-header ${lang}`}>
            <div className={`hero-logo-container ${lang}`}>
              <HomeHeroLogo className="hero-logo"/>
            </div>
            <div className={`hero-heading ${lang}`}>
              {content.heading ? <h1>{content.heading}</h1> : null}
            </div>
          </div>
          <div className="hero-countdown-container">
            <Countdown localization={localization}/>
          </div>
          { localization('global.applyNow') && localization('global.applyUrl') ? <a href={localization('global.applyUrl')} target="_blank" rel="noopener" className={`hero-apply-container ${lang}`}>
            <h2>{localization('global.applyNow')}</h2>
            <HeroApplyArrow className="hero-apply-arrow"/>
          </a> : null }
        </div>
      </div>
    )
  } else {
    return null
  }
  
}

export default HeroHome


// WEBPACK FOOTER //
// ./src/components/Hero/hero-home.js